// GraphQL queries and mutations for customer management (Adobe Commerce SaaS)

// Query to get complete customer profile (equivalent to GET /rest/V1/customers/me)
export const CUSTOMER_PROFILE_QUERY = `
  query GetCustomerProfile {
    customer {
      firstname
      lastname
      email
      created_at
      prefix
      middlename
      suffix
      taxvat
      date_of_birth
      gender
      telephone
      default_billing
      default_shipping
      is_subscribed
      group {
        uid
      }
      addresses {
        id
        firstname
        lastname
        middlename
        prefix
        suffix
        street
        city
        region {
          region_code
          region
          region_id
        }
        postcode
        country_code
        telephone
        fax
        company
        default_billing
        default_shipping
        custom_attributesV2(attributeCodes: null) {
          code
          ... on AttributeValue {
            value
          }
        }
      }
      custom_attributes(attributeCodes: null) {
        code
        ... on AttributeValue {
          value
        }
      }
    }
  }
`;



// Data transformation helper to convert GraphQL customer response to REST format
export const transformCustomerDataToRest = (customer) => {
  if (!customer) return null;

  return {
    id: customer.email,
    email: customer.email,
    firstname: customer.firstname,
    lastname: customer.lastname,
    middlename: customer.middlename,
    prefix: customer.prefix,
    suffix: customer.suffix,
    taxvat: customer.taxvat,
    gender: customer.gender,
    is_subscribed: customer.is_subscribed,
    created_at: customer.created_at,
    date_of_birth: customer.date_of_birth,
    telephone: customer.telephone,
    default_billing: customer.default_billing,
    default_shipping: customer.default_shipping,
    group_id: customer.group?.uid || null,
    custom_attributes: (customer.custom_attributes || []).map(attr => ({
      attribute_code: attr.code,
      value: attr.value ?? null
    })),
    addresses: (customer.addresses || []).map(addr => ({
      id: addr.id,
      firstname: addr.firstname,
      lastname: addr.lastname,
      middlename: addr.middlename,
      prefix: addr.prefix,
      suffix: addr.suffix,
      street: addr.street,
      city: addr.city,
      postcode: addr.postcode,
      country_id: addr.country_code,
      regionId: addr.region?.region_id, // Add regionId at top level for compatibility
      countryId: addr.country_code, // Add countryId for compatibility
      region: {
        region: addr.region?.region,
        region_code: addr.region?.region_code,
        region_id: addr.region?.region_id
      },
      telephone: addr.telephone,
      fax: addr.fax,
      company: addr.company,
      default_billing: addr.default_billing,
      default_shipping: addr.default_shipping,
      custom_attributes: (addr.custom_attributesV2 || []).map(attr => ({
        attribute_code: attr.code,
        value: attr.value ?? null
      })),
      extension_attributes: []
    }))
  };
};

